// Ansicht der Sonstige-Liste (Handoff Sonstige Kontakte §1): Kacheln oder Liste, je Browser gemerkt.
export type SonstigeAnsicht = 'kacheln' | 'liste';

export const ANSICHT_SCHLUESSEL = 'immo-sonstige-ansicht';

type Speicher = Pick<Storage, 'getItem' | 'setItem'>;

function standardSpeicher(): Speicher | null {
  try { return typeof window === 'undefined' ? null : window.localStorage; } catch { return null; }
}

/** Gemerkte Ansicht; ohne Wert, bei unbekanntem Wert oder gesperrtem Speicher „kacheln“. */
export function leseAnsicht(speicher: Pick<Storage, 'getItem'> | null = standardSpeicher()): SonstigeAnsicht {
  try { return speicher?.getItem(ANSICHT_SCHLUESSEL) === 'liste' ? 'liste' : 'kacheln'; } catch { return 'kacheln'; }
}

export function merkeAnsicht(ansicht: SonstigeAnsicht, speicher: Pick<Storage, 'setItem'> | null = standardSpeicher()): void {
  try { speicher?.setItem(ANSICHT_SCHLUESSEL, ansicht); } catch { /* privates Fenster: nur nicht merken */ }
}
